export default "__VITE_ASSET__BNwFARZB__"